// extracted by mini-css-extract-plugin
export default {"suggested-prompt":"SuggestedPrompt_suggested-prompt__LlXyk","suggested-prompt-group":"SuggestedPrompt_suggested-prompt-group__gSz50"};